import script from "./ElementPositionPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementPositionPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ElementPositionPanel.vue?vue&type=style&index=0&id=d9abf9a4&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9abf9a4"]])

export default __exports__